import { createSelector } from 'reselect';

const selectExpensesState = (state) => state.expensesReducer;

export const getExpenses = () =>
  createSelector(selectExpensesState, (state) => {
    if (!state.activeMonth) return [];
    return state.expensesByMonth[state.activeMonth] || [];
  });

export const getExpensesTrend = () =>
  createSelector(selectExpensesState, (state) => state.trend);

export const getExpensesLoading = () =>
  createSelector(selectExpensesState, (state) => state.loadingExpenses);

export const getTrendLoading = () =>
  createSelector(selectExpensesState, (state) => state.loadingTrend);

export const getCachedExpenseMonths = () =>
  createSelector(selectExpensesState, (state) => Object.keys(state.expensesByMonth || {}));
